import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { ControlGeocercaService } from '../services/flota/control-geocerca-service/control-geocerca.service';
import { MatSidenav } from '@angular/material/sidenav/sidenav';
import { Gtp } from '../shared/gtp';
import { ListaMovilesService } from '../shared/services/lista-moviles.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MapToolsService } from '../shared/services/map-tools.service';

//import { UpgradeComponent } from 'src/app/modules/upgrade/upgrade.component';
import { MatDialog } from '@angular/material/dialog';
import { MembresiaDialogComponent } from './membresia-dialog/membresia-dialog.component';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  //@ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('sidenav1', { static: false }) adminSidebar: MatSidenav;
  @ViewChild('mainSidebar', { static: false }) mainSidebar: MatSidenav;
  @ViewChild('rightSidebar', { static: false }) rightSidebar: MatSidenav;
  //@ViewChild('rightSidebarMain', { static: false, read: ViewContainerRef }) rightSidebarMain: ViewContainerRef;

  rightSidebarMain = null;

  tipoDePlan = "planFull";
  tiposPlanes = "";

  isMobile:boolean = false;

  splashVisible = true;

  constructor(
    private router: Router,
    public gtp: Gtp,
    public dialog: MatDialog, //new line
    private listamovilesservice: ListaMovilesService,
    private geocercasService: ControlGeocercaService,
    private mapsAPILoader: MapsAPILoader,
    private cd:ChangeDetectorRef,
    private mapToolsService: MapToolsService
  ) {
    this.configBaseUrl();
    this.isMobile = this.gtp.isMobile();
    // Aseguramos que el splash sea visible desde el inicio
    this.splashVisible = true;
  }

  ngOnInit(): void {
    // Primero mostramos el splash, luego cargamos todo
    setTimeout(() => {
      this.setObservers();
      this.mapsAPILoader.load().then(() => {
        this.getFlotaMoviles();
        this.getGeocercas();
        this.setRightSidebar();

        // Solo cuando todo está cargado, ocultamos el splash
        setTimeout(() => {
          this.splashVisible = false;
          // Activamos el sidebar inmediatamente después de ocultar el splash
          setTimeout(() => {
            if (!this.isMobile) {
              this.mainSidebar.open();
              // Forzamos que el sidebar permanezca abierto
              this.gtp.setMainSidebar(true);
            }
            // Volvemos a cargar los móviles para asegurarnos que aparezcan en el mapa
            setTimeout(() => {
              this.listamovilesservice.callflotaMoviles();
            }, 500);
            this.cd.detectChanges();
          }, 100);
          this.cd.detectChanges();
        }, 2000);
      });
    }, 500);
  }

  ngAfterViewInit(){
    // Solo configuramos los componentes visuales cuando el splash no está visible
    if (!this.splashVisible) {
      this.mobileConfig();
      // Aseguramos que el sidebar esté abierto también aquí
      if (!this.isMobile) {
        setTimeout(() => {
          this.mainSidebar.open();
          this.gtp.setMainSidebar(true);
          this.cd.detectChanges();
        }, 100);
      }
      this.cd.detectChanges();//detectamos el cambio para evitar errores
    }
  }

  mobileConfig(){
    if (!this.isMobile) {
      this.mainSidebar.open();
    }
  }

  //Configura el enviroment tras recargar el inicio del sitio.
  configBaseUrl(){
    let user = JSON.parse(this.gtp.getUserData());
    // this.tipoDePlan = (user.cliente_plan_id == 3 ) ? "planBasico" : "planFull";
    switch (user.cliente_plan_id) {
      case 1:
        this.tipoDePlan = 'planFull'
      break;
      case 2:
        this.tipoDePlan = 'planMedio'
      break;
      case 3:
        this.tipoDePlan= 'planBasico'
      break;
      case 4:
        this.tipoDePlan= 'planTanque'
      break;
      default:
      break;
    }

    switch (user.cliente_plan_id) {
      case 1:
        this.tiposPlanes = 'PRO'
      break;
      case 2:
        this.tiposPlanes = 'PLUS'
      break;
      case 3:
        this.tiposPlanes= 'LITE'
      break;
      case 4:
        this.tiposPlanes= 'TANQUES'
      break;
      default:
      break;
    }
    environment.limiteconsultas = user.limiteconsultas;
    environment.baseUrl = user.baseUrl;
    environment.baseUrlV2 = user.baseUrlV2;
  }

  setObservers() {
    this.setMainSidebar();
    this.setAdminSidebar();
  }

  closeSideNav() {
    this.mainSidebar.toggle();
    //this.rightSidebar.toggle();
  }

  setMainSidebar(){
    //Abre o Cierra Main Sidebar
    this.gtp.getMainSidebar().subscribe(data => {
      if (data) {
        this.mainSidebar.open();
      } else {
        this.mainSidebar.close();
      }
    });
  }
  setAdminSidebar(){
    //Abre o Cierra Admin Sidebar
    this.gtp.getAdminSidebar().subscribe(data => {
      if (data) {
        this.adminSidebar.open();
      } else {
        this.adminSidebar.close();
      }
    });
  }

  setRightSidebar() {
    this.gtp.getRightSidebar().subscribe(data => {
      if (data.open) {
        if (data.component) {
          this.rightSidebarMain = null;
          this.rightSidebarMain = data.component;
        }
        if(this.gtp.rightSidebarOpened) {
          this.rightSidebar.open();
        }
      } else {
        this.rightSidebar.close();
      }
    });
  }

  /**
   * Llama al listado de móviles a plasmar en el mapa
   */
  getFlotaMoviles() {
    this.listamovilesservice.getflotaMoviles().subscribe((res) => {
      // No actualizar marcadores del mapa si estamos en modo recorrido
      if (!this.mapToolsService.tipoMapaActual?.recorrido) {
        this.listamovilesservice.setMarkers(res);
      }
    });
    this.listamovilesservice.callflotaMoviles();
  }

  /**
   * Llama al listado de geocercas
   */
  getGeocercas() {
    this.geocercasService.callGeocercas();
  }

  goHome() {
    this.router.navigate(['/']);
  }

  getSplashImage(): string {
    switch (this.tipoDePlan) {
      case 'planTanque':
        return 'assets/disen/logo/logo-gtp-blanco.png';
      case 'planBasico':
        return 'assets/disen/iconos-y-splash/Splash GTP Lite.png';
      case 'planMedio':
        return 'assets/disen/iconos-y-splash/Splash GTP Plus.png';
      case 'planFull':
      default:
        return 'assets/disen/iconos-y-splash/Splash GTP Pro.png';
    }
  }

  /**
   * Abre el diálogo para mostrar opciones de membresía
   */
  openMembresiaDialog(): void {
    const dialogConfig = {
      panelClass: 'membresia-dialog-container',
      maxWidth: '95vw',
      width: '90%',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
      position: { top: '20px' },
      data: {
        planActual: this.tiposPlanes
      }
    };

    // En dispositivos móviles, abrir a pantalla completa
    if (this.isMobile) {
      dialogConfig['width'] = '100vw';
      dialogConfig['height'] = '100vh';
      dialogConfig['maxWidth'] = '100vw';
      dialogConfig['position'] = { top: '0' };
    }

    const dialogRef = this.dialog.open(MembresiaDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Acción a realizar si el usuario desea actualizar su plan
        console.log('Usuario interesado en actualizar plan:', result);
      }
    });
  }

}
